/*
 * @Date: 2023-02-14 09:56:13
 * @LastEditTime: 2026-01-31 10:00:00
 * @Description: 线下课程API - 同步小程序端功能
 */
import { request } from "@/request/request";
import { parameterChange } from "@/utils/utils";

export default {
  // 获取最新活动列表
  getLatestActivity(data) {
    return request({
      url: "/offline_course/getLatestActivity?" + parameterChange(data),
      method: "get",
      data,
    });
  },
  // 获取线下培训/实操课列表
  getCoursePageList(data) {
    return request({
      url: "/offline_course/getCoursePageList?" + parameterChange(data),
      method: "get",
      data,
    });
  },
  // 期数列表
  getIssuePageList(data) {
    return request({
      url: "/offline_course/getIssuePageList?" + parameterChange(data),
      method: "get",
      data,
    });
  },
  // 期数详情
  getIssueDetail(data) {
    return request({
      url: "/offline_course/getIssueDetail?" + parameterChange(data),
      method: "get",
      data,
    });
  },
  // 公益活动列表
  getActivityPageList(data) {
    return request({
      url: "/offline_course/getActivityPageList?" + parameterChange(data),
      method: "get",
      data,
    });
  },
  // 公益活动详情
  getActivityDetail(data) {
    return request({
      url: "/offline_course/getActivityDetail?" + parameterChange(data),
      method: "get",
      data,
    });
  },
  // 获取课程详情
  getCourseDetail(data) {
    return request({
      url: "/offline_course/getCourseDetail?" + parameterChange(data),
      method: "get",
      data,
    });
  },
  // 获取报名状态
  getEnrollCheck(data) {
    return request({
      url: "/offline_course/getEnrollCheck?" + parameterChange(data),
      method: "get",
      data,
    });
  },
  // 获取报名表单
  getEnrollForm(data) {
    return request({
      url: "/offline_course/getEnrollForm?" + parameterChange(data),
      method: "get",
      data,
    });
  },
  // 课程/活动报名
  enroll(data) {
    return request({
      url: "/offline_course/enroll",
      method: "post",
      data,
    });
  },
  // 获取直播间链接
  getLiveUrl(data) {
    return request({
      url: "/offline_course/getLiveUrl?" + parameterChange(data),
      method: "get",
      data,
    });
  },
  // 线下课签到
  signIn(data) {
    return request({
      url: "/offline_course/signIn",
      method: "post",
      data,
    });
  },
  // 加入团队/班级
  join(data) {
    return request({
      url: "/offline_course/join",
      method: "post",
      data,
    });
  },
  // 更新报名订单状态
  updateEnrollOrder(data) {
    return request({
      url: "/offline_course/updateEnrollOrder",
      method: "post",
      data,
    });
  },
};
